<div class="form-group" [formGroup]="enfantForm">
    <div class="label-form-cnaf">
        <h4>Votre {{libelleIndexEnfant}} enfant</h4>
    </div>
    <ccd-boutons-radio 
        name="questionAgeMax"
        id="QUESTION_AGE_MAX_{{enfant.id}}"
        libelle="Votre enfant a moins de {{ageMax}} ans"
        [configurationBoutons]="QUESTION_OUI_NON"
        [valeur]="valeurMoins21ans"
        (dataChange)="dataChangeQuestionAgeMax($event)">
    </ccd-boutons-radio>

    <ccd-boutons-radio 
       *ngIf="valeurMoins21ans !== undefined"
        name="questionRevenuDernierMois"
        id="QUESTION_REVENUS_DERNIERSMOIS_{{enfant.id}}"
        libelle="Votre enfant a gagné plus de 4500 euros au cours des 12 derniers mois"
        [configurationBoutons]="QUESTION_OUI_NON"
        [valeur]="valeurRevenue12DernierMois"
        (dataChange)="dataChangeQuestionRevenueDernierMois($event)">
    </ccd-boutons-radio>

    <app-ressources-enfant
        *ngIf="enfant.revenue12DernierMois"
        name="ressourcesEnfant"
        indexEnfant="{{enfant.id}}"
        [ressourcesEnfant]="enfant.ressources"
        (dataChange)="dataChangeRessources($event)">
    </app-ressources-enfant>

    <ccd-boutons-radio 
       *ngIf="afficherSitPro"
        name="questionSitPro"
        id="QUESTION_SITPRO_{{enfant.id}}"
        libelle="Votre enfant est"
        [configurationBoutons]="QUESTION_SIT_PRO"
        [valeur]="enfant.codeSituationPro"
        (dataChange)="enfant.codeSituationPro = $event">
    </ccd-boutons-radio>
</div>
